export const STATUS_LABELS: Record<string, string> = {
  TODO: "To-do",
  IN_PROGRESS: "In progress",
  DONE: "Done",
};